import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { CreateRateCardFormBody } from "./create-rate-card-form-body"

export function CreateRateCardDialog({ regimeId }) {
    return (
        <DataInputDialog
            initialValue={{
                name: "",
                skillMapId: null,
                regimeId: regimeId || null,
            }}
            okCaption="Create"
            okDisabled={isInvalid}
        >
            <DialogTitle sx={{ pb: 3 }}>Add Rate Card</DialogTitle>
            <DialogContent sx={{ pb: 0.5 }}>
                <CreateRateCardFormBody regimeId={regimeId} />
            </DialogContent>
        </DataInputDialog>
    )
}

function isInvalid(v) {
    if (!v?.name?.trim()) return true
    if (!v?.skillMapId) return true
    return false
}
